import _curry from 'lodash/curry';
import _filter from 'lodash/filter';

// Readers
import filterTypeReader from '../readers/FilterType';
var isFilterTypeSelectedByDefault = _curry(function (defaultIdsSet, filterType) {
  var filterTypeId = filterTypeReader.id(filterType);
  return defaultIdsSet.has(filterTypeId);
});
export var getDefaultFilterTypes = function getDefaultFilterTypes(defaultFilterTypeIds, filterTypes) {
  var defaultIdsSet = new Set(defaultFilterTypeIds);
  var selectedFilterTypes = _filter(filterTypes, isFilterTypeSelectedByDefault(defaultIdsSet));
  return selectedFilterTypes;
};